import { Component, inject } from '@angular/core'
import { SpinnerService } from '../../services/spinner.service'

@Component({
  selector: 'app-spinner',
  standalone: true,
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
})
export class SpinnerComponent {
  spinnerService = inject(SpinnerService)
}
